import React from 'react'
import ConfirmPopup from '../../common/confirm-popup'

const RemoveGroupDialog = (props) => {
  return (
    <ConfirmPopup header="Are you sure you want to delete this group?"
                  onClose={(result) => props.onClose(result)}
                  confirmLabel="Delete">
      <div className="ta-left">
        <p>
          By deleting this group, outlets previously associated will no longer be able to view
          articles and / or reward icons that were linked to this group.
        </p>
      </div>
    </ConfirmPopup>
  )
};

export default RemoveGroupDialog;


// WEBPACK FOOTER //
// ./src/components/admin/groups/remove-group-dialog.jsx